import React from 'react';

class ImageModal extends React.Component {
  onOutsideClick = event => {
    let isClickInside = this.refs.image_modal_content.contains(event.target);
    if (!isClickInside) {
      this.props.onClear();
    }
  };

  render() {
    const { url, alt } = this.props;
    return (
      <div className="image-modal" onClick={this.onOutsideClick}>
        <img src={url} alt={alt} ref="image_modal_content" />
      </div>
    );
  }
}

ImageModal.propTypes = {
  onClear: React.PropTypes.func.isRequired,
  url: React.PropTypes.string.isRequired,
  alt: React.PropTypes.string.isRequired,
};

export default ImageModal;



/** WEBPACK FOOTER **
 ** ./src/components/image-modal/index.js
 **/